var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Checkbox, FormControlLabel, Grid, ListItem, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Get } from "../../../../api/api";
import { DeclinedJobReasonListUrl, getCustomerDeclinedJobswithPriceUrl, getSavedPreviousDeclinedJobs, upsertPreviousAdditionalJobsAppointmentnURL, upsertPreviousAdditionalJobsEstimateURL, upsertPreviousAdditionalJobsInspectionURL } from "../../../../api/url";
import { ArrowDownIcon, ArrowUPIcon, BlueDropdownIcon, BlueUpIcon } from "../../../../assets/images";
import { MuiStack } from "../../../../components";
import { MuiLoaderButton } from "../../../../components/atoms/loaderButton";
import { EParentModuleName, ESystemName } from "../../../../constants";
import { showLoader, showNotification } from "../../../../redux/commonSlice";
import { createAPI, getListAPI } from "../../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import useAnalyticsEventTracker from "../../../../utils/useAnalyticsEventTracker";
var DeclinedAdditionalJobsComponent = function (props) {
    var _additionalJobs$Labou4, _additionalJobs$Labou5, _additionalJobs$Part4, _additionalJobs$Part5, _additionalJobs$Labou6, _additionalJobs$Part6, _additionalJobs$Part7, _additionalJobs$Labou7;
    var parentModuleName = props.parentModuleName, jobCount = props.jobCount, jobCardID = props.jobCardID, currentJobCardData = props.currentJobCardData, disabledPreviousDeclined = props.disabledPreviousDeclined;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var trackButtonClick = useAnalyticsEventTracker("DeclinedAdditionalJobsComponent");
    var _a = useParams(), estimateId = _a.estimateId, appointmentId = _a.appointmentId, inspectionId = _a.inspectionId;
    var _b = useState(false), isOpenSection = _b[0], setIsOpenSection = _b[1];
    var _c = useState([]), additionalJobs = _c[0], setAdditionalJobs = _c[1];
    var _d = useState([]), rejectReasonRemarkList = _d[0], setRejectReasonRemarkList = _d[1];
    var dispatch = useAppDispatch();
    var _e = useState(true), disableSaveBtn = _e[0], setDisableSaveBtn = _e[1];
    var _f = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; }), getSearchTypeList = _f.getSearchTypeList, declinedAdditionalJobs = _f.declinedAdditionalJobs, savedAdditionalJobs = _f.savedAdditionalJobs;
    useEffect(function () {
        getRejectRemarkList();
    }, []);
    useEffect(function () {
        if (jobCardID) {
            setIsOpenSection(false);
        }
    }, [jobCardID]);
    useEffect(function () {
        if (jobCardID !== "" && jobCardID !== undefined) {
            getAdditionalJobs();
        }
    }, [jobCardID]);
    var getAdditionalJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d, _currentJobCardData$d2, _currentJobCardData$d3, _response$payload, declineJobRequestBody, response, _response$payload2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    declineJobRequestBody = {
                        ParentId: jobCardID,
                        InstallBaseId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d = currentJobCardData.data) === null || _currentJobCardData$d === void 0 ? void 0 : _currentJobCardData$d.InstallBaseId,
                        ServiceDetailType: 1,
                        OrganizationId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d2 = currentJobCardData.data) === null || _currentJobCardData$d2 === void 0 ? void 0 : _currentJobCardData$d2.OrganizationId,
                        VinNo: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d3 = currentJobCardData.data) === null || _currentJobCardData$d3 === void 0 ? void 0 : _currentJobCardData$d3.VinNo,
                        Entity: "JobCard"
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "declinedAdditionalJobs",
                            url: getCustomerDeclinedJobswithPriceUrl,
                            request: declineJobRequestBody
                        }))];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.value) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) === 200) {
                        setAdditionalJobs(response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.data);
                        getSavedAdditionalJobs();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedAdditionalJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d4, _currentJobCardData$d5, _currentJobCardData$d6, _response, _response2, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        RepairTypeId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d4 = currentJobCardData.data) === null || _currentJobCardData$d4 === void 0 ? void 0 : _currentJobCardData$d4.RepairTypeId,
                        ServiceDetailType: 1,
                        JobSource: "PreviousDeclined",
                        OrganizationId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d5 = currentJobCardData.data) === null || _currentJobCardData$d5 === void 0 ? void 0 : _currentJobCardData$d5.OrganizationId,
                        VinNo: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d6 = currentJobCardData.data) === null || _currentJobCardData$d6 === void 0 ? void 0 : _currentJobCardData$d6.VinNo,
                        Entity: parentModuleName === EParentModuleName.ServiceEstimate ? ESystemName.Estimate : parentModuleName
                    };
                    response = {};
                    if (!(parentModuleName === EParentModuleName.ServiceEstimate)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedAdditionalJobs",
                            url: getSavedPreviousDeclinedJobs,
                            request: _objectSpread(_objectSpread({}, request), {}, {
                                PreJobCardDocumentId: estimateId
                            })
                        }))];
                case 1:
                    response = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(parentModuleName === EParentModuleName.Appointment)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedAdditionalJobs",
                            url: getSavedPreviousDeclinedJobs,
                            request: _objectSpread(_objectSpread({}, request), {}, {
                                PreJobCardDocumentId: appointmentId
                            })
                        }))];
                case 3:
                    response = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(parentModuleName === EParentModuleName.Inspection)) return [3 /*break*/, 6];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedAdditionalJobs",
                            url: getSavedPreviousDeclinedJobs,
                            request: _objectSpread(_objectSpread({}, request), {}, {
                                PreJobCardDocumentId: inspectionId
                            })
                        }))];
                case 5:
                    response = _a.sent();
                    _a.label = 6;
                case 6:
                    if ((_response = response) !== null && _response !== void 0 && (_response = _response.payload) !== null && _response !== void 0 && _response.value.success && ((_response2 = response) === null || _response2 === void 0 || (_response2 = _response2.payload) === null || _response2 === void 0 ? void 0 : _response2.value.statusCode) == 200) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRejectRemarkList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        Get(DeclinedJobReasonListUrl).then(function (response) {
                            if (response.success && response.data) {
                                setRejectReasonRemarkList(response.data);
                            }
                            resolve(response);
                        }).catch(function (getRejectRemarkListError) {
                            reject(getRejectRemarkListError);
                        });
                        return [2 /*return*/];
                    });
                }); })];
        });
    }); };
    var updateData = function (item, type) {
        if (type === "Labour") {
            var _additionalJobs$Labou;
            var _data = additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Labou = additionalJobs.Labour) === null || _additionalJobs$Labou === void 0 ? void 0 : _additionalJobs$Labou.map(function (i, index) {
                if ((item === null || item === void 0 ? void 0 : item.ChildId) === (i === null || i === void 0 ? void 0 : i.ChildId)) {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isResonOpen: !(i !== null && i !== void 0 && i.isResonOpen)
                    });
                    return _i;
                }
                else {
                    return i;
                }
            });
            setAdditionalJobs(_objectSpread(_objectSpread({}, additionalJobs), {}, {
                Labour: __spreadArray([], _data, true)
            }));
        }
        if (type === "Part") {
            var _additionalJobs$Part;
            var _data = additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Part = additionalJobs.Part) === null || _additionalJobs$Part === void 0 ? void 0 : _additionalJobs$Part.map(function (i, index) {
                if ((item === null || item === void 0 ? void 0 : item.ChildId) === (i === null || i === void 0 ? void 0 : i.ChildId)) {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isResonOpen: !(i !== null && i !== void 0 && i.isResonOpen)
                    });
                    return _i;
                }
                else {
                    return i;
                }
            });
            setAdditionalJobs(_objectSpread(_objectSpread({}, additionalJobs), {}, {
                Part: __spreadArray([], _data, true)
            }));
        }
    };
    var getReason = function (option) {
        var i = rejectReasonRemarkList === null || rejectReasonRemarkList === void 0 ? void 0 : rejectReasonRemarkList.find(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId); });
        if (i)
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                id: "Reason-Name",
                variant: "body2"
            }, i === null || i === void 0 ? void 0 : i.Name), /*#__PURE__*/ React.createElement(Typography, {
                id: "Remarks",
                variant: "body2",
                color: "text.secondary"
            }, (option === null || option === void 0 ? void 0 : option.Remarks) !== "" ? option === null || option === void 0 ? void 0 : option.Remarks : "-"));
    };
    var upsertAdditionalJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _additionalJobs$Part2, _additionalJobs$Labou2, _response3, _response4, partList, labourList, additionalPartArray, additionalLabourArray, payload, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "Declined_Additional_Jobs_Save", undefined);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    partList = additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Part2 = additionalJobs.Part) === null || _additionalJobs$Part2 === void 0 ? void 0 : _additionalJobs$Part2.filter(function (item) { return item.isSelected; });
                    labourList = additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Labou2 = additionalJobs.Labour) === null || _additionalJobs$Labou2 === void 0 ? void 0 : _additionalJobs$Labou2.filter(function (item) { return item.isSelected; });
                    additionalPartArray = [];
                    additionalLabourArray = [];
                    return [4 /*yield*/, (labourList === null || labourList === void 0 ? void 0 : labourList.forEach(function (elem) {
                            var objLabour = {};
                            objLabour["Quantity"] = elem.Quantity !== null ? elem.Quantity : 1;
                            objLabour["SystemName"] = "Labour";
                            objLabour["ChildId"] = elem.ChildId;
                            objLabour["ChildName"] = elem.LabourName || elem.Name;
                            objLabour["ChildCode"] = elem.LabourCode || elem.Code;
                            objLabour["LabourName"] = elem.LabourName || elem.Name;
                            objLabour['JobSource'] = 'PreviousDeclined';
                            objLabour['ServiceDetailType'] = 1;
                            additionalLabourArray.push(_objectSpread({}, objLabour));
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, (partList === null || partList === void 0 ? void 0 : partList.forEach(function (elem) {
                            var objPart = {};
                            objPart["Quantity"] = elem.Quantity !== null ? elem.Quantity : 1;
                            objPart["SystemName"] = "Product";
                            objPart["ChildId"] = elem.ChildId;
                            objPart["ChildName"] = elem.PartName || elem.Name;
                            objPart["ChildCode"] = elem.PartCode || elem.Code;
                            objPart["PartName"] = elem.PartName || elem.Name;
                            objPart['JobSource'] = 'PreviousDeclined';
                            objPart['ServiceDetailType'] = 1;
                            additionalPartArray.push(_objectSpread({}, objPart));
                        }))];
                case 2:
                    _a.sent();
                    payload = {};
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        AdditionalJobs: __spreadArray(__spreadArray([], additionalLabourArray, true), additionalPartArray, true)
                    });
                    response = {};
                    if (!(parentModuleName === EParentModuleName.ServiceEstimate)) return [3 /*break*/, 4];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        EstimateId: estimateId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsEstimateURL,
                            request: payload
                        }))];
                case 3:
                    response = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(parentModuleName === EParentModuleName.Appointment)) return [3 /*break*/, 6];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        AppointmentId: appointmentId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsAppointmentnURL,
                            request: payload
                        }))];
                case 5:
                    response = _a.sent();
                    _a.label = 6;
                case 6:
                    if (!(parentModuleName === EParentModuleName.Inspection)) return [3 /*break*/, 8];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        InspectionId: inspectionId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsInspectionURL,
                            request: payload
                        }))];
                case 7:
                    response = _a.sent();
                    _a.label = 8;
                case 8:
                    if ((_response3 = response) !== null && _response3 !== void 0 && (_response3 = _response3.payload) !== null && _response3 !== void 0 && (_response3 = _response3.value) !== null && _response3 !== void 0 && _response3.success && ((_response4 = response) === null || _response4 === void 0 || (_response4 = _response4.payload) === null || _response4 === void 0 || (_response4 = _response4.value) === null || _response4 === void 0 ? void 0 : _response4.statusCode) == 200) {
                        getSavedAdditionalJobs();
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Additional jobs saved successfully",
                            type: "success"
                        }));
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    setDisableSaveBtn(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var disablePart = function (option) {
        var _savedAdditionalJobs$;
        var _find = savedAdditionalJobs === null || savedAdditionalJobs === void 0 || (_savedAdditionalJobs$ = savedAdditionalJobs.data) === null || _savedAdditionalJobs$ === void 0 || (_savedAdditionalJobs$ = _savedAdditionalJobs$.Part) === null || _savedAdditionalJobs$ === void 0 ? void 0 : _savedAdditionalJobs$.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        if (_find !== null && _find !== void 0 && _find.ChildId) {
            return true;
        }
        else {
            return false;
        }
    };
    var disableLabour = function (option) {
        var _savedAdditionalJobs$2;
        var _find = savedAdditionalJobs === null || savedAdditionalJobs === void 0 || (_savedAdditionalJobs$2 = savedAdditionalJobs.data) === null || _savedAdditionalJobs$2 === void 0 || (_savedAdditionalJobs$2 = _savedAdditionalJobs$2.Labour) === null || _savedAdditionalJobs$2 === void 0 ? void 0 : _savedAdditionalJobs$2.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        if (_find !== null && _find !== void 0 && _find.ChildId) {
            return true;
        }
        else {
            return false;
        }
    };
    var onGroupChange = function (e, item, type) {
        if (type === "Part") {
            var _additionalJobs$Part3;
            var _data = additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Part3 = additionalJobs.Part) === null || _additionalJobs$Part3 === void 0 ? void 0 : _additionalJobs$Part3.map(function (i, index) {
                if ((item === null || item === void 0 ? void 0 : item.ChildId) === (i === null || i === void 0 ? void 0 : i.ChildId)) {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isSelected: !(i !== null && i !== void 0 && i.isSelected)
                    });
                    return _i;
                }
                else {
                    return i;
                }
            });
            setAdditionalJobs(_objectSpread(_objectSpread({}, additionalJobs), {}, {
                Part: __spreadArray([], _data, true)
            }));
        }
        if (type === "Labour") {
            var _additionalJobs$Labou3;
            var _data = additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Labou3 = additionalJobs.Labour) === null || _additionalJobs$Labou3 === void 0 ? void 0 : _additionalJobs$Labou3.map(function (i, index) {
                if ((item === null || item === void 0 ? void 0 : item.ChildId) === (i === null || i === void 0 ? void 0 : i.ChildId)) {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isSelected: !(i !== null && i !== void 0 && i.isSelected)
                    });
                    return _i;
                }
                else {
                    return i;
                }
            });
            setAdditionalJobs(_objectSpread(_objectSpread({}, additionalJobs), {}, {
                Labour: __spreadArray([], _data, true)
            }));
        }
        setDisableSaveBtn(false);
    };
    console.log("savedAdditionalJobs", savedAdditionalJobs);
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        sx: {
            border: "1px solid #AFD5FF",
            borderRadius: "12px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        display: "flex",
        padding: 2,
        borderBottom: isOpenSection ? "1px solid #DEE4EB" : "",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5"
    }, t("Additional Jobs"), " "), /*#__PURE__*/ React.createElement(Typography, {
        id: "Additional-Job-Count",
        sx: {
            backgroundColor: "#EEF6FF",
            padding: "3px 8px",
            borderRadius: "12px",
            border: "1px solid #AFD5FF",
            justifyContent: "center",
            color: "#3697FF",
            ml: "5px"
        },
        variant: "subtitle2"
    }, jobCount)), /*#__PURE__*/ React.createElement(MuiStack, null, isOpenSection ? /*#__PURE__*/ React.createElement("img", {
        id: "ArrowUPIcon",
        src: ArrowUPIcon,
        onClick: function () {
            setIsOpenSection(!isOpenSection);
            trackButtonClick("ButtonClickEvent", "AdditionalJobsClose", undefined);
        }
    }) : /*#__PURE__*/ React.createElement("img", {
        id: "ArrowDownIcon",
        src: ArrowDownIcon,
        onClick: function () {
            trackButtonClick("ButtonClickEvent", "AdditionalJobsOpen", undefined);
            setIsOpenSection(!isOpenSection);
        }
    }))), isOpenSection && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        display: "flex",
        rowSpacing: 1
    }, (additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Labou4 = additionalJobs.Labour) === null || _additionalJobs$Labou4 === void 0 ? void 0 : _additionalJobs$Labou4.length) > 0 && (additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Labou5 = additionalJobs.Labour) === null || _additionalJobs$Labou5 === void 0 ? void 0 : _additionalJobs$Labou5.map(function (option) {
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 6
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(ListItem, {
            sx: {
                display: "flex",
                alignItems: "center",
                flexDirection: 'row',
                justifyContent: 'space-between'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            onChange: function (e) {
                onGroupChange(e, option, "Labour");
            },
            disabled: disabledPreviousDeclined || disableLabour(option),
            control: /*#__PURE__*/ React.createElement(Checkbox, {
                checked: (option === null || option === void 0 ? void 0 : option.isSelected) || disableLabour(option)
            }),
            label: option === null || option === void 0 ? void 0 : option.LabourName,
            sx: {
                padding: "0px",
                fontWeight: 500,
                fontSize: "14px"
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            marginLeft: 3
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: 'secondary'
        }, option !== null && option !== void 0 && option.LabourCode ? "#".concat(option === null || option === void 0 ? void 0 : option.LabourCode) : '-'))), /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                backgroundColor: "#F4F7FA",
                padding: "3px 8px",
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                color: "#1B1D21",
                ml: "5px"
            },
            variant: "subtitle2"
        }, "L"))), (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            display: "flex",
            sx: {
                pl: 6
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: "#0052FF"
        }, t('REASON')), option !== null && option !== void 0 && option.isResonOpen ? /*#__PURE__*/ React.createElement("img", {
            width: "10px",
            src: BlueUpIcon,
            style: {
                marginLeft: "3px"
            },
            onClick: function () { return updateData(option, "Labour"); }
        }) : /*#__PURE__*/ React.createElement("img", {
            src: BlueDropdownIcon,
            width: "15px",
            onClick: function () { return updateData(option, "Labour"); },
            style: {
                marginLeft: "1px"
            }
        })), (option === null || option === void 0 ? void 0 : option.isResonOpen) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sx: {
                backgroundColor: "#F4F7FA",
                padding: 2,
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                marginY: 1,
                ml: 6,
                mr: 2
            }
        }, getReason(option))));
    })), (additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Part4 = additionalJobs.Part) === null || _additionalJobs$Part4 === void 0 ? void 0 : _additionalJobs$Part4.length) > 0 && (additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Part5 = additionalJobs.Part) === null || _additionalJobs$Part5 === void 0 ? void 0 : _additionalJobs$Part5.map(function (option) {
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 6
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sx: {
                justifyContent: "center",
                alignItems: "center"
            }
        }, /*#__PURE__*/ React.createElement(ListItem, {
            sx: {
                display: "flex",
                alignItems: "center",
                flexDirection: 'row',
                justifyContent: 'space-between'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            id: "Part-Container",
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            onChange: function (e) {
                onGroupChange(e, option, "Part");
            },
            disabled: disabledPreviousDeclined || disablePart(option),
            control: /*#__PURE__*/ React.createElement(Checkbox, {
                id: "Checkbox",
                checked: (option === null || option === void 0 ? void 0 : option.isSelected) || disablePart(option)
            }),
            label: option === null || option === void 0 ? void 0 : option.PartName,
            sx: {
                width: "100%",
                padding: "0px",
                fontWeight: 500,
                fontSize: "14px"
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            id: "Part-Code",
            marginLeft: 3
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: 'secondary'
        }, option !== null && option !== void 0 && option.PartCode ? "#".concat(option === null || option === void 0 ? void 0 : option.PartCode) : '-'))), /*#__PURE__*/ React.createElement(Typography, {
            id: "Item-Type",
            sx: {
                backgroundColor: "#F4F7FA",
                padding: "3px 8px",
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                color: "#1B1D21",
                ml: "5px"
            },
            variant: "subtitle2"
        }, "P"))), (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            display: "flex",
            sx: {
                pl: 6
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: "#0052FF"
        }, t('REASON')), option !== null && option !== void 0 && option.isResonOpen ? /*#__PURE__*/ React.createElement("img", {
            id: "BlueUpIcon",
            width: "10px",
            src: BlueUpIcon,
            style: {
                marginLeft: "3px"
            },
            onClick: function () { return updateData(option, "Part"); }
        }) : /*#__PURE__*/ React.createElement("img", {
            id: "BlueDropdownIcon",
            src: BlueDropdownIcon,
            width: "15px",
            onClick: function () { return updateData(option, "Part"); },
            style: {
                marginLeft: "1px"
            }
        })), (option === null || option === void 0 ? void 0 : option.isResonOpen) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sx: {
                backgroundColor: "#F4F7FA",
                padding: 2,
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                marginY: 1,
                ml: 6,
                mr: 2
            }
        }, getReason(option))));
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            marginX: 2,
            paddingTop: 2,
            borderBottom: "1px solid #DEE4EB"
        }
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: "flex",
            justifyContent: "end",
            padding: 2
        }
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "test-ride-start-end-btn",
        variant: "contained",
        size: "medium",
        disabled: disabledPreviousDeclined || (additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Labou6 = additionalJobs.Labour) === null || _additionalJobs$Labou6 === void 0 ? void 0 : _additionalJobs$Labou6.length) <= 0 && (additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Part6 = additionalJobs.Part) === null || _additionalJobs$Part6 === void 0 ? void 0 : _additionalJobs$Part6.length) <= 0 || (additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Part7 = additionalJobs.Part) === null || _additionalJobs$Part7 === void 0 || (_additionalJobs$Part7 = _additionalJobs$Part7.filter(function (item) { return item.isSelected; })) === null || _additionalJobs$Part7 === void 0 ? void 0 : _additionalJobs$Part7.length) <= 0 && (additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Labou7 = additionalJobs.Labour) === null || _additionalJobs$Labou7 === void 0 || (_additionalJobs$Labou7 = _additionalJobs$Labou7.filter(function (item) { return item.isSelected; })) === null || _additionalJobs$Labou7 === void 0 ? void 0 : _additionalJobs$Labou7.length) <= 0 || disableSaveBtn,
        color: "primary",
        onClick: function () {
            upsertAdditionalJobs();
        },
        name: t("Save")
    }))));
};
export default DeclinedAdditionalJobsComponent;
